const AIS140Availability={
    "Andaman and Nicobar Islands": [
        {"name":"Port Blair",  "price": 4400 , "availability":true}
    ],
    "Haryana": [
        {"name":"Faridabad",  "price": 4400 , "availability":true},
        {"name":"Gurgaon",  "price": 4400 , "availability":true},
        {"name":"Hisar",  "price": 4400 , "availability":true},
        {"name":"Rohtak",  "price": 4400 , "availability":true},
        {"name":"Panipat",  "price": 4400 , "availability":true},
        {"name":"Karnal",  "price": 4400 , "availability":true},
        {"name":"Sonipat",  "price": 4400 , "availability":true},
        {"name":"Yamunanagar",  "price": 4400 , "availability":true},
        {"name":"Panchkula",  "price": 4400 , "availability":true},
        {"name":"Bhiwani",  "price": 4400 , "availability":true},
        {"name":"Bahadurgarh",  "price": 4400 , "availability":true},
        {"name":"Jind",  "price": 4400 , "availability":true},
        {"name":"Sirsa",  "price": 4400 , "availability":true},
        {"name":"Thanesar",  "price": 4400 , "availability":true},
        {"name":"Kaithal",  "price": 4400 , "availability":true},
        {"name":"Palwal",  "price": 4400 , "availability":true},
        {"name":"Rewari",  "price": 4400 , "availability":true},
        {"name":"Hansi",  "price": 4400 , "availability":true},
        {"name":"Narnaul",  "price": 4400 , "availability":true},
        {"name":"Fatehabad",  "price": 4400 , "availability":true},
        {"name":"Gohana",  "price": 4400 , "availability":true},
        {"name":"Tohana",  "price": 4400 , "availability":true},
        {"name":"Narwana",  "price": 4400 , "availability":true},
        {"name":"Mandi Dabwali",  "price": 4400 , "availability":true},
        {"name":"Charkhi Dadri",  "price": 4400 , "availability":true},
        {"name":"Shahbad",  "price": 4400 , "availability":true},
        {"name":"Pehowa",  "price": 4400 , "availability":true},
        {"name":"Samalkha",  "price": 4400 , "availability":true},
        {"name":"Pinjore",  "price": 4400 , "availability":true},
        {"name":"Ladwa",  "price": 4400 , "availability":true},
        {"name":"Sohna",  "price": 4400 , "availability":true},
        {"name":"Safidon",  "price": 4400 , "availability":true},
        {"name":"Taraori",  "price": 4400 , "availability":true},
        {"name":"Mahendragarh",  "price": 4400 , "availability":true},
        {"name":"Ratia",  "price": 4400 , "availability":true},
        {"name":"Rania",  "price": 4400 , "availability":true},
        {"name":"Sarsod",  "price": 4400 , "availability":true}
    ],
    "Tamil Nadu": [
        {"name":"Chennai",  "price": 4400 , "availability":true},
        {"name":"Coimbatore",  "price": 4400 , "availability":true},
        {"name":"Madurai",  "price": 4400 , "availability":true},
        {"name":"Tiruchirappalli",  "price": 4400 , "availability":true},
        {"name":"Salem",  "price": 4400 , "availability":true},
        {"name":"Tirunelveli",  "price": 4400 , "availability":true},
        {"name":"Tiruppur",  "price": 4400 , "availability":true},
        {"name":"Ranipet",  "price": 4400 , "availability":true},
        {"name":"Nagercoil",  "price": 4400 , "availability":true},
        {"name":"Thanjavur",  "price": 4400 , "availability":true},
        {"name":"Vellore",  "price": 4400 , "availability":true},
        {"name":"Kancheepuram",  "price": 4400 , "availability":true},
        {"name":"Erode",  "price": 4400 , "availability":true},
        {"name":"Tiruvannamalai",  "price": 4400 , "availability":true},
        {"name":"Pollachi",  "price": 4400 , "availability":true},
        {"name":"Rajapalayam",  "price": 4400 , "availability":true},
        {"name":"Sivakasi",  "price": 4400 , "availability":true},
        {"name":"Pudukkottai",  "price": 4400 , "availability":true},
         {"name":"Neyveli(TS)",  "price": 4400 , "availability":true},
        {"name":"Nagapattinam",  "price": 4400 , "availability":true},
        {"name":"Viluppuram",  "price": 4400 , "availability":true},
        {"name":"Tiruchengode",  "price": 4400 , "availability":true},
        {"name":"Vaniyambadi",  "price": 4400 , "availability":true},
        {"name":"Theni Allinagaram",  "price": 4400 , "availability":true},
        {"name":"Udhagamandalam",  "price": 4400 , "availability":true},
        {"name":"Aruppukkottai",  "price": 4400 , "availability":true},
        {"name":"Paramakudi",  "price": 4400 , "availability":true},
        {"name":"Arakkonam",  "price": 4400 , "availability":true},
        {"name":"Virudhachalam",  "price": 4400 , "availability":true},
        {"name":"Srivilliputhur",  "price": 4400 , "availability":true},
        {"name":"Tindivanam",  "price": 4400 , "availability":true},
        {"name":"Virudhunagar",  "price": 4400 , "availability":true},
        {"name":"Karur",  "price": 4400 , "availability":true},
        {"name":"Valparai",  "price": 4400 , "availability":true},
        {"name":"Sankarankovil",  "price": 4400 , "availability":true},
        {"name":"Tenkasi",  "price": 4400 , "availability":true},
        {"name":"Palani",  "price": 4400 , "availability":true},
        {"name":"Pattukkottai",  "price": 4400 , "availability":true},
        {"name":"Tirupathur",  "price": 4400 , "availability":true},
        {"name":"Ramanathapuram",  "price": 4400 , "availability":true},
        {"name":"Udumalaipettai",  "price": 4400 , "availability":true},
        {"name":"Gobichettipalayam",  "price": 4400 , "availability":true},
        {"name":"Thiruvarur",  "price": 4400 , "availability":true},
        {"name":"Thiruvallur",  "price": 4400 , "availability":true},
        {"name":"Panruti",  "price": 4400 , "availability":true},
        {"name":"Namakkal",  "price": 4400 , "availability":true},
        {"name":"Thirumangalam",  "price": 4400 , "availability":true},
        {"name":"Vikramasingapuram",  "price": 4400 , "availability":true},
        {"name":"Nellikuppam",  "price": 4400 , "availability":true},
        {"name":"Rasipuram",  "price": 4400 , "availability":true},
        {"name":"Tiruttani",  "price": 4400 , "availability":true},
        {"name":"Nandivaram-Guduvancheri",  "price": 4400 , "availability":true},
        {"name":"Periyakulam",  "price": 4400 , "availability":true},
        {"name":"Pernampattu",  "price": 4400 , "availability":true},
        {"name":"Vellakoil",  "price": 4400 , "availability":true},
        {"name":"Sivaganga",  "price": 4400 , "availability":true},
        {"name":"Vadalur",  "price": 4400 , "availability":true},
        {"name":"Rameshwaram",  "price": 4400 , "availability":true},
        {"name":"Tiruvethipuram",  "price": 4400 , "availability":true},
        {"name":"Perambalur",  "price": 4400 , "availability":true},
        {"name":"Usilampatti",  "price": 4400 , "availability":true},
        {"name":"Vedaranyam",  "price": 4400 , "availability":true},
        {"name":"Sathyamangalam",  "price": 4400 , "availability":true},
        {"name":"Puliyankudi",  "price": 4400 , "availability":true},
        {"name":"Nanjikottai",  "price": 4400 , "availability":true},
        {"name":"Thuraiyur",  "price": 4400 , "availability":true},
        {"name":"Sirkali",  "price": 4400 , "availability":true},
        {"name":"Tiruchendur",  "price": 4400 , "availability":true},
        {"name":"Periyasemur",  "price": 4400 , "availability":true},
        {"name":"Sattur",  "price": 4400 , "availability":true},
        {"name":"Vandavasi",  "price": 4400 , "availability":true},
        {"name":"Tharamangalam",  "price": 4400 , "availability":true},
        {"name":"Tirukkoyilur",  "price": 4400 , "availability":true},
        {"name":"Oddanchatram",  "price": 4400 , "availability":true},
        {"name":"Palladam",  "price": 4400 , "availability":true},
        {"name":"Vadakkuvalliyur",  "price": 4400 , "availability":true},
        {"name":"Tirukalukundram",  "price": 4400 , "availability":true},
        {"name":"Uthamapalayam",  "price": 4400 , "availability":true},
        {"name":"Surandai",  "price": 4400 , "availability":true},
        {"name":"Sankari",  "price": 4400 , "availability":true},
        {"name":"Shenkottai",  "price": 4400 , "availability":true},
        {"name":"Vadipatti",  "price": 4400 , "availability":true},
        {"name":"Sholingur",  "price": 4400 , "availability":true},
        {"name":"Tirupathur",  "price": 4400 , "availability":true},
        {"name":"Manachanallur",  "price": 4400 , "availability":true},
        {"name":"Viswanatham",  "price": 4400 , "availability":true},
        {"name":"Polur",  "price": 4400 , "availability":true},
        {"name":"Panagudi",  "price": 4400 , "availability":true},
        {"name":"Uthiramerur",  "price": 4400 , "availability":true},
        {"name":"Thiruthuraipoondi",  "price": 4400 , "availability":true},
        {"name":"Pallapatti",  "price": 4400 , "availability":true},
        {"name":"Ponneri",  "price": 4400 , "availability":true},
        {"name":"Lalgudi",  "price": 4400 , "availability":true},
        {"name":"Natham",  "price": 4400 , "availability":true},
        {"name":"Unnamalaikadai",  "price": 4400 , "availability":true},
        {"name":"P.N.Patti",  "price": 4400 , "availability":true},
        {"name":"Tharangambadi",  "price": 4400 , "availability":true},
        {"name":"Tittakudi",  "price": 4400 , "availability":true},
        {"name":"Pacode",  "price": 4400 , "availability":true},
        {"name":"O Valley",  "price": 4400 , "availability":true},
        {"name":"Suriyampalayam",  "price": 4400 , "availability":true},
        {"name":"Sholavandan",  "price": 4400 , "availability":true},
        {"name":"Thammampatti",  "price": 4400 , "availability":true},
        {"name":"Namagiripettai",  "price": 4400 , "availability":true},
        {"name":"Peravurani",  "price": 4400 , "availability":true},
        {"name":"Parangipettai",  "price": 4400 , "availability":true},
        {"name":"Pudupattinam",  "price": 4400 , "availability":true},
        {"name":"Pallikonda",  "price": 4400 , "availability":true},
        {"name":"Sivagiri",  "price": 4400 , "availability":true},
        {"name":"Punjaipugalur",  "price": 4400 , "availability":true},
        {"name":"Padmanabhapuram",  "price": 4400 , "availability":true},
        {"name":"Thirupuvanam",  "price": 4400 , "availability":true}
    ],
    "Madhya Pradesh": [
        {"name":"Indore",  "price": 4400 , "availability":true},
        {"name":"Bhopal",  "price": 4400 , "availability":true},
        {"name":"Jabalpur",  "price": 4400 , "availability":true},
        {"name":"Gwalior",  "price": 4400 , "availability":true},
        {"name":"Ujjain",  "price": 4400 , "availability":true},
        {"name":"Sagar",  "price": 4400 , "availability":true},
        {"name":"Ratlam",  "price": 4400 , "availability":true},
        {"name":"Satna",  "price": 4400 , "availability":true},
        {"name":"Murwara (Katni)",  "price": 4400 , "availability":true},
        {"name":"Morena",  "price": 4400 , "availability":true},
        {"name":"Singrauli",  "price": 4400 , "availability":true},
        {"name":"Rewa",  "price": 4400 , "availability":true},
        {"name":"Vidisha",  "price": 4400 , "availability":true},
        {"name":"Ganjbasoda",  "price": 4400 , "availability":true},
        {"name":"Shivpuri",  "price": 4400 , "availability":true},
        {"name":"Mandsaur",  "price": 4400 , "availability":true},
        {"name":"Neemuch",  "price": 4400 , "availability":true},
        {"name":"Nagda",  "price": 4400 , "availability":true},
        {"name":"Itarsi",  "price": 4400 , "availability":true},
        {"name":"Sarni",  "price": 4400 , "availability":true},
        {"name":"Sehore",  "price": 4400 , "availability":true},
        {"name":"Mhow Cantonment",  "price": 4400 , "availability":true},
        {"name":"Seoni",  "price": 4400 , "availability":true},
        {"name":"Balaghat",  "price": 4400 , "availability":true},
        {"name":"Ashok Nagar",  "price": 4400 , "availability":true},
        {"name":"Tikamgarh",  "price": 4400 , "availability":true},
        {"name":"Shahdol",  "price": 4400 , "availability":true},
        {"name":"Pithampur",  "price": 4400 , "availability":true},
        {"name":"Alirajpur",  "price": 4400 , "availability":true},
        {"name":"Mandla",  "price": 4400 , "availability":true},
        {"name":"Sheopur",  "price": 4400 , "availability":true},
        {"name":"Shajapur",  "price": 4400 , "availability":true},
        {"name":"Panna",  "price": 4400 , "availability":true},
        {"name":"Raghogarh-Vijaypur",  "price": 4400 , "availability":true},
        {"name":"Sendhwa",  "price": 4400 , "availability":true},
        {"name":"Sidhi",  "price": 4400 , "availability":true},
        {"name":"Pipariya",  "price": 4400 , "availability":true},
        {"name":"Shujalpur",  "price": 4400 , "availability":true},
        {"name":"Sironj",  "price": 4400 , "availability":true},
        {"name":"Pandhurna",  "price": 4400 , "availability":true},
        {"name":"Nowgong",  "price": 4400 , "availability":true},
        {"name":"Mandideep",  "price": 4400 , "availability":true},
        {"name":"Sihora",  "price": 4400 , "availability":true},
        {"name":"Raisen",  "price": 4400 , "availability":true},
        {"name":"Lahar",  "price": 4400 , "availability":true},
        {"name":"Maihar",  "price": 4400 , "availability":true},
        {"name":"Sanawad",  "price": 4400 , "availability":true},
        {"name":"Sabalgarh",  "price": 4400 , "availability":true},
        {"name":"Umaria",  "price": 4400 , "availability":true},
        {"name":"Porsa",  "price": 4400 , "availability":true},
        {"name":"Narsinghgarh",  "price": 4400 , "availability":true},
        {"name":"Malaj Khand",  "price": 4400 , "availability":true},
        {"name":"Sarangpur",  "price": 4400 , "availability":true},
        {"name":"Mundi",  "price": 4400 , "availability":true},
        {"name":"Nepanagar",  "price": 4400 , "availability":true},
        {"name":"Pasan",  "price": 4400 , "availability":true},
        {"name":"Mahidpur",  "price": 4400 , "availability":true},
        {"name":"Seoni-Malwa",  "price": 4400 , "availability":true},
        {"name":"Rehli",  "price": 4400 , "availability":true},
        {"name":"Manawar",  "price": 4400 , "availability":true},
        {"name":"Rahatgarh",  "price": 4400 , "availability":true},
        {"name":"Panagar",  "price": 4400 , "availability":true},
        {"name":"Wara Seoni",  "price": 4400 , "availability":true},
        {"name":"Tarana",  "price": 4400 , "availability":true},
        {"name":"Sausar",  "price": 4400 , "availability":true},
        {"name":"Rajgarh",  "price": 4400 , "availability":true},
        {"name":"Niwari",  "price": 4400 , "availability":true},
        {"name":"Mauganj",  "price": 4400 , "availability":true},
        {"name":"Manasa",  "price": 4400 , "availability":true},
        {"name":"Nainpur",  "price": 4400 , "availability":true},
        {"name":"Prithvipur",  "price": 4400 , "availability":true},
        {"name":"Sohagpur",  "price": 4400 , "availability":true},
        {"name": "Nowrozabad(Khodargama)",  "price": 4400 , "availability":true},
        {"name":"Shamgarh",  "price": 4400 , "availability":true},
        {"name":"Maharajpur",  "price": 4400 , "availability":true},
        {"name":"Multai",  "price": 4400 , "availability":true},
        {"name":"Pali",  "price": 4400 , "availability":true},
        {"name":"Pachore",  "price": 4400 , "availability":true},
        {"name":"Rau",  "price": 4400 , "availability":true},
        {"name":"Mhowgaon",  "price": 4400 , "availability":true},
        {"name":"Vijaypur",  "price": 4400 , "availability":true},
        {"name":"Narsinghgarh",  "price": 4400 , "availability":true}
    ],
    "Jharkhand": [
        {"name":"Dhanbad",  "price": 4400 , "availability":true},
        {"name":"Ranchi",  "price": 4400 , "availability":true},
        {"name":"Jamshedpur",  "price": 4400 , "availability":true},
         {"name":"BokaroSteel City",  "price": 4400 , "availability":true},
        {"name":"Deoghar",  "price": 4400 , "availability":true},
        {"name":"Phusro",  "price": 4400 , "availability":true},
        {"name":"Adityapur",  "price": 4400 , "availability":true},
        {"name":"Hazaribag",  "price": 4400 , "availability":true},
        {"name":"Giridih",  "price": 4400 , "availability":true},
        {"name":"Ramgarh",  "price": 4400 , "availability":true},
        {"name":"Jhumri Tilaiya",  "price": 4400 , "availability":true},
        {"name":"Saunda",  "price": 4400 , "availability":true},
        {"name":"Sahibganj",  "price": 4400 , "availability":true},
         {"name":"Medininagar(Daltonganj)",  "price": 4400 , "availability":true},
        {"name":"Chaibasa",  "price": 4400 , "availability":true},
        {"name":"Chatra",  "price": 4400 , "availability":true},
        {"name":"Gumia",  "price": 4400 , "availability":true},
        {"name":"Dumka",  "price": 4400 , "availability":true},
        {"name":"Madhupur",  "price": 4400 , "availability":true},
        {"name":"Chirkunda",  "price": 4400 , "availability":true},
        {"name":"Pakaur",  "price": 4400 , "availability":true},
        {"name":"Simdega",  "price": 4400 , "availability":true},
        {"name":"Musabani",  "price": 4400 , "availability":true},
        {"name":"Mihijam",  "price": 4400 , "availability":true},
        {"name":"Patratu",  "price": 4400 , "availability":true},
        {"name":"Lohardaga",  "price": 4400 , "availability":true},
       {"name": "Tenu dam-cum-Kathhara",  "price": 4400 , "availability":true}
    ],
    "Mizoram": [
        {"name":"Aizawl",  "price": 4400 , "availability":true},
        {"name":"Lunglei",  "price": 4400 , "availability":true},
        {"name":"Saiha",  "price": 4400 , "availability":true}
    ],
    "Nagaland": [
        {"name":"Dimapur",  "price": 4400 , "availability":true},
        {"name":"Kohima",  "price": 4400 , "availability":true},
        {"name":"Zunheboto",  "price": 4400 , "availability":true},
        {"name":"Tuensang",  "price": 4400 , "availability":true},
        {"name":"Wokha",  "price": 4400 , "availability":true},
        {"name":"Mokokchung",  "price": 4400 , "availability":true}
    ],
    "Himachal Pradesh": [
        {"name":"Shimla",  "price": 4400 , "availability":true},
        {"name":"Mandi",  "price": 4400 , "availability":true},
        {"name":"Solan",  "price": 4400 , "availability":true},
        {"name":"Nahan",  "price": 4400 , "availability":true},
        {"name":"Sundarnagar",  "price": 4400 , "availability":true},
        {"name":"Palampur",  "price": 4400 , "availability":true},
        {"name":"Kullu",  "price": 4400 , "availability":true}
    ],
    "Tripura": [
        {"name":"Agartala",  "price": 4400 , "availability":true},
        {"name":"Udaipur",  "price": 4400 , "availability":true},
        {"name":"Dharmanagar",  "price": 4400 , "availability":true},
        {"name":"Pratapgarh",  "price": 4400 , "availability":true},
        {"name":"Kailasahar",  "price": 4400 , "availability":true},
        {"name":"Belonia",  "price": 4400 , "availability":true},
        {"name":"Khowai",  "price": 4400 , "availability":true}
    ],
    "Andhra Pradesh": [
        {"name":"Visakhapatnam",  "price": 4400 , "availability":true},
        {"name":"Vijayawada",  "price": 4400 , "availability":true},
        {"name":"Guntur",  "price": 4400 , "availability":true},
        {"name":"Nellore",  "price": 4400 , "availability":true},
        {"name":"Kurnool",  "price": 4400 , "availability":true},
        {"name":"Rajahmundry",  "price": 4400 , "availability":true},
        {"name":"Kakinada",  "price": 4400 , "availability":true},
        {"name":"Tirupati",  "price": 4400 , "availability":true},
        {"name":"Anantapur",  "price": 4400 , "availability":true},
        {"name":"Kadapa",  "price": 4400 , "availability":true},
        {"name":"Vizianagaram",  "price": 4400 , "availability":true},
        {"name":"Eluru",  "price": 4400 , "availability":true},
        {"name":"Ongole",  "price": 4400 , "availability":true},
        {"name":"Nandyal",  "price": 4400 , "availability":true},
        {"name":"Machilipatnam",  "price": 4400 , "availability":true},
        {"name":"Adoni",  "price": 4400 , "availability":true},
        {"name":"Tenali",  "price": 4400 , "availability":true},
        {"name":"Chittoor",  "price": 4400 , "availability":true},
        {"name":"Hindupur",  "price": 4400 , "availability":true},
        {"name":"Proddatur",  "price": 4400 , "availability":true},
        {"name":"Bhimavaram",  "price": 4400 , "availability":true},
        {"name":"Madanapalle",  "price": 4400 , "availability":true},
        {"name":"Guntakal",  "price": 4400 , "availability":true},
        {"name":"Dharmavaram",  "price": 4400 , "availability":true},
        {"name":"Gudivada",  "price": 4400 , "availability":true},
        {"name":"Srikakulam",  "price": 4400 , "availability":true},
        {"name":"Narasaraopet",  "price": 4400 , "availability":true},
        {"name":"Rajampet",  "price": 4400 , "availability":true},
        {"name":"Tadpatri",  "price": 4400 , "availability":true},
        {"name":"Tadepalligudem",  "price": 4400 , "availability":true},
        {"name":"Chilakaluripet",  "price": 4400 , "availability":true},
        {"name":"Yemmiganur",  "price": 4400 , "availability":true},
        {"name":"Kadiri",  "price": 4400 , "availability":true},
        {"name":"Chirala",  "price": 4400 , "availability":true},
        {"name":"Anakapalle",  "price": 4400 , "availability":true},
        {"name":"Kavali",  "price": 4400 , "availability":true},
        {"name":"Palacole",  "price": 4400 , "availability":true},
        {"name":"Sullurpeta",  "price": 4400 , "availability":true},
        {"name":"Tanuku",  "price": 4400 , "availability":true},
        {"name":"Rayachoti",  "price": 4400 , "availability":true},
        {"name":"Srikalahasti",  "price": 4400 , "availability":true},
        {"name":"Bapatla",  "price": 4400 , "availability":true},
        {"name":"Naidupet",  "price": 4400 , "availability":true},
        {"name":"Nagari",  "price": 4400 , "availability":true},
        {"name":"Gudur",  "price": 4400 , "availability":true},
        {"name":"Vinukonda",  "price": 4400 , "availability":true},
        {"name":"Narasapuram",  "price": 4400 , "availability":true},
        {"name":"Nuzvid",  "price": 4400 , "availability":true},
        {"name":"Markapur",  "price": 4400 , "availability":true},
        {"name":"Ponnur",  "price": 4400 , "availability":true},
        {"name":"Kandukur",  "price": 4400 , "availability":true},
        {"name":"Bobbili",  "price": 4400 , "availability":true},
        {"name":"Rayadurg",  "price": 4400 , "availability":true},
        {"name":"Samalkot",  "price": 4400 , "availability":true},
        {"name":"Jaggaiahpet",  "price": 4400 , "availability":true},
        {"name":"Tuni",  "price": 4400 , "availability":true},
        {"name":"Amalapuram",  "price": 4400 , "availability":true},
        {"name":"Bheemunipatnam",  "price": 4400 , "availability":true},
        {"name":"Venkatagiri",  "price": 4400 , "availability":true},
        {"name":"Sattenapalle",  "price": 4400 , "availability":true},
        {"name":"Pithapuram",  "price": 4400 , "availability":true},
        {"name":"Palasa Kasibugga",  "price": 4400 , "availability":true},
        {"name":"Parvathipuram",  "price": 4400 , "availability":true},
        {"name":"Macherla",  "price": 4400 , "availability":true},
        {"name":"Gooty",  "price": 4400 , "availability":true},
        {"name":"Salur",  "price": 4400 , "availability":true},
        {"name":"Mandapeta",  "price": 4400 , "availability":true},
        {"name":"Jammalamadugu",  "price": 4400 , "availability":true},
        {"name":"Peddapuram",  "price": 4400 , "availability":true},
        {"name":"Punganur",  "price": 4400 , "availability":true},
        {"name":"Nidadavole",  "price": 4400 , "availability":true},
        {"name":"Repalle",  "price": 4400 , "availability":true},
        {"name":"Ramachandrapuram",  "price": 4400 , "availability":true},
        {"name":"Kovvur",  "price": 4400 , "availability":true},
        {"name":"Tiruvuru",  "price": 4400 , "availability":true},
        {"name":"Uravakonda",  "price": 4400 , "availability":true},
        {"name":"Narsipatnam",  "price": 4400 , "availability":true},
        {"name":"Yerraguntla",  "price": 4400 , "availability":true},
        {"name":"Pedana",  "price": 4400 , "availability":true},
        {"name":"Puttur",  "price": 4400 , "availability":true},
        {"name":"Renigunta",  "price": 4400 , "availability":true},
        {"name":"Rajam",  "price": 4400 , "availability":true},
        {"name":"Srisailam Project",  "price": 4400 , "availability":true}
    ],
    "Punjab": [
        {"name":"Ludhiana",  "price": 4400 , "availability":true},
        {"name":"Patiala",  "price": 4400 , "availability":true},
        {"name":"Amritsar",  "price": 4400 , "availability":true},
        {"name":"Jalandhar",  "price": 4400 , "availability":true},
        {"name":"Bathinda",  "price": 4400 , "availability":true},
        {"name":"Pathankot",  "price": 4400 , "availability":true},
        {"name":"Hoshiarpur",  "price": 4400 , "availability":true},
        {"name":"Batala",  "price": 4400 , "availability":true},
        {"name":"Moga",  "price": 4400 , "availability":true},
        {"name":"Malerkotla",  "price": 4400 , "availability":true},
        {"name":"Khanna",  "price": 4400 , "availability":true},
        {"name":"Mohali",  "price": 4400 , "availability":true},
        {"name":"Barnala",  "price": 4400 , "availability":true},
        {"name":"Firozpur",  "price": 4400 , "availability":true},
        {"name":"Phagwara",  "price": 4400 , "availability":true},
        {"name":"Kapurthala",  "price": 4400 , "availability":true},
        {"name":"Zirakpur",  "price": 4400 , "availability":true},
        {"name":"Kot Kapura",  "price": 4400 , "availability":true},
        {"name":"Faridkot",  "price": 4400 , "availability":true},
        {"name":"Muktsar",  "price": 4400 , "availability":true},
        {"name":"Rajpura",  "price": 4400 , "availability":true},
        {"name":"Sangrur",  "price": 4400 , "availability":true},
        {"name":"Fazilka",  "price": 4400 , "availability":true},
        {"name":"Gurdaspur",  "price": 4400 , "availability":true},
        {"name":"Kharar",  "price": 4400 , "availability":true},
        {"name":"Gobindgarh",  "price": 4400 , "availability":true},
        {"name":"Mansa",  "price": 4400 , "availability":true},
        {"name":"Malout",  "price": 4400 , "availability":true},
        {"name":"Nabha",  "price": 4400 , "availability":true},
        {"name":"Tarn Taran",  "price": 4400 , "availability":true},
        {"name":"Jagraon",  "price": 4400 , "availability":true},
        {"name":"Sunam",  "price": 4400 , "availability":true},
        {"name":"Dhuri",  "price": 4400 , "availability":true},
        {"name":"Firozpur Cantt.",  "price": 4400 , "availability":true},
        {"name":"Sirhind Fatehgarh Sahib",  "price": 4400 , "availability":true},
        {"name":"Rupnagar",  "price": 4400 , "availability":true},
        {"name":"Jalandhar Cantt.",  "price": 4400 , "availability":true},
        {"name":"Samana",  "price": 4400 , "availability":true},
        {"name":"Nawanshahr",  "price": 4400 , "availability":true},
        {"name":"Rampura Phul",  "price": 4400 , "availability":true},
        {"name":"Nangal",  "price": 4400 , "availability":true},
        {"name":"Nakodar",  "price": 4400 , "availability":true},
        {"name":"Zira",  "price": 4400 , "availability":true},
        {"name":"Patti",  "price": 4400 , "availability":true},
        {"name":"Raikot",  "price": 4400 , "availability":true},
        {"name":"Longowal",  "price": 4400 , "availability":true},
        {"name":"Urmar Tanda",  "price": 4400 , "availability":true},
        {"name":"Morinda India",  "price": 4400 , "availability":true},
        {"name":"Phillaur",  "price": 4400 , "availability":true},
        {"name":"Pattran",  "price": 4400 , "availability":true},
        {"name":"Qadian",  "price": 4400 , "availability":true},
        {"name":"Sujanpur",  "price": 4400 , "availability":true},
        {"name":"Mukerian",  "price": 4400 , "availability":true},
        {"name":"Talwara",  "price": 4400 , "availability":true}
    ],
    "Chandigarh": [
        {"name":"Chandigarh",  "price": 4400 , "availability":true}
    ],
    "Rajasthan": [
        {"name":"Jaipur",  "price": 4400 , "availability":true},
        {"name":"Jodhpur",  "price": 4400 , "availability":true},
        {"name":"Bikaner",  "price": 4400 , "availability":true},
        {"name":"Udaipur",  "price": 4400 , "availability":true},
        {"name":"Ajmer",  "price": 4400 , "availability":true},
        {"name":"Bhilwara",  "price": 4400 , "availability":true},
        {"name":"Alwar",  "price": 4400 , "availability":true},
        {"name":"Bharatpur",  "price": 4400 , "availability":true},
        {"name":"Pali",  "price": 4400 , "availability":true},
        {"name":"Barmer",  "price": 4400 , "availability":true},
        {"name":"Sikar",  "price": 4400 , "availability":true},
        {"name":"Tonk",  "price": 4400 , "availability":true},
        {"name":"Sadulpur",  "price": 4400 , "availability":true},
        {"name":"Sawai Madhopur",  "price": 4400 , "availability":true},
        {"name":"Nagaur",  "price": 4400 , "availability":true},
        {"name":"Makrana",  "price": 4400 , "availability":true},
        {"name":"Sujangarh",  "price": 4400 , "availability":true},
        {"name":"Sardarshahar",  "price": 4400 , "availability":true},
        {"name":"Ladnu",  "price": 4400 , "availability":true},
        {"name":"Ratangarh",  "price": 4400 , "availability":true},
        {"name":"Nokha",  "price": 4400 , "availability":true},
        {"name":"Nimbahera",  "price": 4400 , "availability":true},
        {"name":"Suratgarh",  "price": 4400 , "availability":true},
        {"name":"Rajsamand",  "price": 4400 , "availability":true},
        {"name":"Lachhmangarh",  "price": 4400 , "availability":true},
         {"name":"Rajgarh(Churu)",  "price": 4400 , "availability":true},
        {"name":"Nasirabad",  "price": 4400 , "availability":true},
        {"name":"Nohar",  "price": 4400 , "availability":true},
        {"name":"Phalodi",  "price": 4400 , "availability":true},
        {"name":"Nathdwara",  "price": 4400 , "availability":true},
        {"name":"Pilani",  "price": 4400 , "availability":true},
        {"name":"Merta City",  "price": 4400 , "availability":true},
        {"name":"Sojat",  "price": 4400 , "availability":true},
        {"name":"Neem-Ka-Thana",  "price": 4400 , "availability":true},
        {"name":"Sirohi",  "price": 4400 , "availability":true},
        {"name":"Pratapgarh",  "price": 4400 , "availability":true},
        {"name":"Rawatbhata",  "price": 4400 , "availability":true},
        {"name":"Sangaria",  "price": 4400 , "availability":true},
        {"name":"Lalsot",  "price": 4400 , "availability":true},
        {"name":"Pilibanga",  "price": 4400 , "availability":true},
        {"name":"Pipar City",  "price": 4400 , "availability":true},
        {"name":"Taranagar",  "price": 4400 , "availability":true},
        {"name":"Vijainagar Ajmer",  "price": 4400 , "availability":true},
        {"name":"Sumerpur",  "price": 4400 , "availability":true},
        {"name":"Sagwara",  "price": 4400 , "availability":true},
        {"name":"Ramganj Mandi",  "price": 4400 , "availability":true},
        {"name":"Lakheri",  "price": 4400 , "availability":true},
        {"name":"Udaipurwati",  "price": 4400 , "availability":true},
        {"name":"Losal",  "price": 4400 , "availability":true},
        {"name":"Sri Madhopur",  "price": 4400 , "availability":true},
        {"name":"Ramngarh",  "price": 4400 , "availability":true},
        {"name":"Rawatsar",  "price": 4400 , "availability":true},
        {"name":"Rajakhera",  "price": 4400 , "availability":true},
        {"name":"Shahpura",  "price": 4400 , "availability":true},
        {"name":"Shahpura",  "price": 4400 , "availability":true},
        {"name":"Raisinghnagar",  "price": 4400 , "availability":true},
        {"name":"Malpura",  "price": 4400 , "availability":true},
        {"name":"Nadbai",  "price": 4400 , "availability":true},
        {"name":"Sanchore",  "price": 4400 , "availability":true},
        {"name":"Nagar",  "price": 4400 , "availability":true},
         {"name":"Rajgarh(Alwar)",  "price": 4400 , "availability":true},
        {"name":"Sheoganj",  "price": 4400 , "availability":true},
        {"name":"Sadri",  "price": 4400 , "availability":true},
        {"name":"Todaraisingh",  "price": 4400 , "availability":true},
        {"name":"Todabhim",  "price": 4400 , "availability":true},
        {"name":"Reengus",  "price": 4400 , "availability":true},
        {"name":"Rajaldesar",  "price": 4400 , "availability":true},
        {"name":"Sadulshahar",  "price": 4400 , "availability":true},
        {"name":"Sambhar",  "price": 4400 , "availability":true},
        {"name":"Prantij",  "price": 4400 , "availability":true},
        {"name":"Mount Abu",  "price": 4400 , "availability":true},
        {"name":"Mangrol",  "price": 4400 , "availability":true},
        {"name":"Phulera",  "price": 4400 , "availability":true},
        {"name":"Mandawa",  "price": 4400 , "availability":true},
        {"name":"Pindwara",  "price": 4400 , "availability":true},
        {"name":"Mandalgarh",  "price": 4400 , "availability":true},
        {"name":"Takhatgarh",  "price": 4400 , "availability":true}
    ],
    "Assam": [
        {"name":"Guwahati",  "price": 4400 , "availability":true},
        {"name":"Silchar",  "price": 4400 , "availability":true},
        {"name":"Dibrugarh",  "price": 4400 , "availability":true},
        {"name":"Nagaon",  "price": 4400 , "availability":true},
        {"name":"Tinsukia",  "price": 4400 , "availability":true},
        {"name":"Jorhat",  "price": 4400 , "availability":true},
        {"name":"Bongaigaon City",  "price": 4400 , "availability":true},
        {"name":"Dhubri",  "price": 4400 , "availability":true},
        {"name":"Diphu",  "price": 4400 , "availability":true},
        {"name":"North Lakhimpur",  "price": 4400 , "availability":true},
        {"name":"Tezpur",  "price": 4400 , "availability":true},
        {"name":"Karimganj",  "price": 4400 , "availability":true},
        {"name":"Sibsagar",  "price": 4400 , "availability":true},
        {"name":"Goalpara",  "price": 4400 , "availability":true},
        {"name":"Barpeta",  "price": 4400 , "availability":true},
        {"name":"Lanka",  "price": 4400 , "availability":true},
        {"name":"Lumding",  "price": 4400 , "availability":true},
        {"name":"Mankachar",  "price": 4400 , "availability":true},
        {"name":"Nalbari",  "price": 4400 , "availability":true},
        {"name":"Rangia",  "price": 4400 , "availability":true},
        {"name":"Margherita",  "price": 4400 , "availability":true},
        {"name":"Mangaldoi",  "price": 4400 , "availability":true},
        {"name":"Silapathar",  "price": 4400 , "availability":true},
        {"name":"Mariani",  "price": 4400 , "availability":true},
        {"name":"Marigaon",  "price": 4400 , "availability":true}
    ],
    "Odisha": [
        {"name":"Bhubaneswar",  "price": 4400 , "availability":true},
        {"name":"Cuttack",  "price": 4400 , "availability":true},
        {"name":"Raurkela",  "price": 4400 , "availability":true},
        {"name":"Brahmapur",  "price": 4400 , "availability":true},
        {"name":"Sambalpur",  "price": 4400 , "availability":true},
        {"name":"Puri",  "price": 4400 , "availability":true},
        {"name":"Baleshwar Town",  "price": 4400 , "availability":true},
        {"name":"Baripada Town",  "price": 4400 , "availability":true},
        {"name":"Bhadrak",  "price": 4400 , "availability":true},
        {"name":"Balangir",  "price": 4400 , "availability":true},
        {"name":"Jharsuguda",  "price": 4400 , "availability":true},
        {"name":"Bargarh",  "price": 4400 , "availability":true},
        {"name":"Paradip",  "price": 4400 , "availability":true},
        {"name":"Bhawanipatna",  "price": 4400 , "availability":true},
        {"name":"Dhenkanal",  "price": 4400 , "availability":true},
        {"name":"Barbil",  "price": 4400 , "availability":true},
        {"name":"Kendujhar",  "price": 4400 , "availability":true},
        {"name":"Sunabeda",  "price": 4400 , "availability":true},
        {"name":"Rayagada",  "price": 4400 , "availability":true},
        {"name":"Jatani",  "price": 4400 , "availability":true},
        {"name":"Byasanagar",  "price": 4400 , "availability":true},
        {"name":"Kendrapara",  "price": 4400 , "availability":true},
        {"name":"Rajagangapur",  "price": 4400 , "availability":true},
        {"name":"Parlakhemundi",  "price": 4400 , "availability":true},
        {"name":"Talcher",  "price": 4400 , "availability":true},
        {"name":"Sundargarh",  "price": 4400 , "availability":true},
        {"name":"Phulabani",  "price": 4400 , "availability":true},
        {"name":"Pattamundai",  "price": 4400 , "availability":true},
        {"name":"Titlagarh",  "price": 4400 , "availability":true},
        {"name":"Nabarangapur",  "price": 4400 , "availability":true},
        {"name":"Soro",  "price": 4400 , "availability":true},
        {"name":"Malkangiri",  "price": 4400 , "availability":true},
        {"name":"Rairangpur",  "price": 4400 , "availability":true},
        {"name":"Tarbha",  "price": 4400 , "availability":true}
    ],
    "Chhattisgarh": [
        {"name":"Raipur",  "price": 4400 , "availability":true},
        {"name":"Bhilai Nagar",  "price": 4400 , "availability":true},
        {"name":"Korba",  "price": 4400 , "availability":true},
        {"name":"Bilaspur",  "price": 4400 , "availability":true},
        {"name":"Durg",  "price": 4400 , "availability":true},
        {"name":"Rajnandgaon",  "price": 4400 , "availability":true},
        {"name":"Jagdalpur",  "price": 4400 , "availability":true},
        {"name":"Raigarh",  "price": 4400 , "availability":true},
        {"name":"Ambikapur",  "price": 4400 , "availability":true},
        {"name":"Mahasamund",  "price": 4400 , "availability":true},
        {"name":"Dhamtari",  "price": 4400 , "availability":true},
        {"name":"Chirmiri",  "price": 4400 , "availability":true},
        {"name":"Bhatapara",  "price": 4400 , "availability":true},
        {"name":"Dalli-Rajhara",  "price": 4400 , "availability":true},
        {"name":"Naila Janjgir",  "price": 4400 , "availability":true},
        {"name":"Tilda Newra",  "price": 4400 , "availability":true},
        {"name":"Mungeli",  "price": 4400 , "availability":true},
        {"name":"Manendragarh",  "price": 4400 , "availability":true},
        {"name":"Sakti",  "price": 4400 , "availability":true}
    ],
    "Jammu and Kashmir": [
        {"name":"Srinagar",  "price": 4400 , "availability":true},
        {"name":"Jammu",  "price": 4400 , "availability":true},
        {"name":"Baramula",  "price": 4400 , "availability":true},
        {"name":"Anantnag",  "price": 4400 , "availability":true},
        {"name":"Sopore",  "price": 4400 , "availability":true},
        {"name":"KathUrban Agglomeration",  "price": 4400 , "availability":true},
        {"name":"Rajauri",  "price": 4400 , "availability":true},
        {"name":"Punch",  "price": 4400 , "availability":true},
        {"name":"Udhampur",  "price": 4400 , "availability":true}
    ],
    "Karnataka": [
        {"name":"Bengaluru",  "price": 4400 , "availability":true},
        {"name":"Hubli-Dharwad",  "price": 4400 , "availability":true},
        {"name":"Belagavi",  "price": 4400 , "availability":true},
        {"name":"Mangaluru",  "price": 4400 , "availability":true},
        {"name":"Davanagere",  "price": 4400 , "availability":true},
        {"name":"Ballari",  "price": 4400 , "availability":true},
        {"name":"Mysore",  "price": 4400 , "availability":true},
        {"name":"Tumkur",  "price": 4400 , "availability":true},
        {"name":"Shivamogga",  "price": 4400 , "availability":true},
        {"name":"Raayachuru",  "price": 4400 , "availability":true},
        {"name":"Robertson Pet",  "price": 4400 , "availability":true},
        {"name":"Kolar",  "price": 4400 , "availability":true},
        {"name":"Mandya",  "price": 4400 , "availability":true},
        {"name":"Udupi",  "price": 4400 , "availability":true},
        {"name":"Chikkamagaluru",  "price": 4400 , "availability":true},
        {"name":"Karwar",  "price": 4400 , "availability":true},
        {"name":"Ranebennuru",  "price": 4400 , "availability":true},
        {"name":"Ranibennur",  "price": 4400 , "availability":true},
        {"name":"Ramanagaram",  "price": 4400 , "availability":true},
        {"name":"Gokak",  "price": 4400 , "availability":true},
        {"name":"Yadgir",  "price": 4400 , "availability":true},
        {"name":"Rabkavi Banhatti",  "price": 4400 , "availability":true},
        {"name":"Shahabad",  "price": 4400 , "availability":true},
        {"name":"Sirsi",  "price": 4400 , "availability":true},
        {"name":"Sindhnur",  "price": 4400 , "availability":true},
        {"name":"Tiptur",  "price": 4400 , "availability":true},
        {"name":"Arsikere",  "price": 4400 , "availability":true},
        {"name":"Nanjangud",  "price": 4400 , "availability":true},
        {"name":"Sagara",  "price": 4400 , "availability":true},
        {"name":"Sira",  "price": 4400 , "availability":true},
        {"name":"Puttur",  "price": 4400 , "availability":true},
        {"name":"Athni",  "price": 4400 , "availability":true},
        {"name":"Mulbagal",  "price": 4400 , "availability":true},
        {"name":"Surapura",  "price": 4400 , "availability":true},
        {"name":"Siruguppa",  "price": 4400 , "availability":true},
        {"name":"Mudhol",  "price": 4400 , "availability":true},
        {"name":"Sidlaghatta",  "price": 4400 , "availability":true},
        {"name":"Shahpur",  "price": 4400 , "availability":true},
        {"name":"Saundatti-Yellamma",  "price": 4400 , "availability":true},
        {"name":"Wadi",  "price": 4400 , "availability":true},
        {"name":"Manvi",  "price": 4400 , "availability":true},
        {"name":"Nelamangala",  "price": 4400 , "availability":true},
        {"name":"Lakshmeshwar",  "price": 4400 , "availability":true},
        {"name":"Ramdurg",  "price": 4400 , "availability":true},
        {"name":"Nargund",  "price": 4400 , "availability":true},
        {"name":"Tarikere",  "price": 4400 , "availability":true},
        {"name":"Malavalli",  "price": 4400 , "availability":true},
        {"name":"Savanur",  "price": 4400 , "availability":true},
        {"name":"Lingsugur",  "price": 4400 , "availability":true},
        {"name":"Vijayapura",  "price": 4400 , "availability":true},
        {"name":"Sankeshwara",  "price": 4400 , "availability":true},
        {"name":"Madikeri",  "price": 4400 , "availability":true},
        {"name":"Talikota",  "price": 4400 , "availability":true},
        {"name":"Sedam",  "price": 4400 , "availability":true},
        {"name":"Shikaripur",  "price": 4400 , "availability":true},
        {"name":"Mahalingapura",  "price": 4400 , "availability":true},
        {"name":"Mudalagi",  "price": 4400 , "availability":true},
        {"name":"Muddebihal",  "price": 4400 , "availability":true},
        {"name":"Pavagada",  "price": 4400 , "availability":true},
        {"name":"Malur",  "price": 4400 , "availability":true},
        {"name":"Sindhagi",  "price": 4400 , "availability":true},
        {"name":"Sanduru",  "price": 4400 , "availability":true},
        {"name":"Afzalpur",  "price": 4400 , "availability":true},
        {"name":"Maddur",  "price": 4400 , "availability":true},
        {"name":"Madhugiri",  "price": 4400 , "availability":true},
        {"name":"Tekkalakote",  "price": 4400 , "availability":true},
        {"name":"Terdal",  "price": 4400 , "availability":true},
        {"name":"Mudabidri",  "price": 4400 , "availability":true},
        {"name":"Magadi",  "price": 4400 , "availability":true},
        {"name":"Navalgund",  "price": 4400 , "availability":true},
        {"name":"Shiggaon",  "price": 4400 , "availability":true},
        {"name":"Shrirangapattana",  "price": 4400 , "availability":true},
        {"name":"Sindagi",  "price": 4400 , "availability":true},
        {"name":"Sakaleshapura",  "price": 4400 , "availability":true},
        {"name":"Srinivaspur",  "price": 4400 , "availability":true},
        {"name":"Ron",  "price": 4400 , "availability":true},
        {"name":"Mundargi",  "price": 4400 , "availability":true},
        {"name":"Sadalagi",  "price": 4400 , "availability":true},
        {"name":"Piriyapatna",  "price": 4400 , "availability":true},
        {"name":"Adyar",  "price": 4400 , "availability":true}
    ],
    "Manipur": [
        {"name":"Imphal",  "price": 4400 , "availability":true},
        {"name":"Thoubal",  "price": 4400 , "availability":true},
        {"name":"Lilong",  "price": 4400 , "availability":true},
        {"name":"Mayang Imphal",  "price": 4400 , "availability":true}
    ],
    "Kerala": [
        {"name":"Thiruvananthapuram",  "price": 4400 , "availability":true},
        {"name":"Kochi",  "price": 4400 , "availability":true},
        {"name":"Kozhikode",  "price": 4400 , "availability":true},
        {"name":"Kollam",  "price": 4400 , "availability":true},
        {"name":"Thrissur",  "price": 4400 , "availability":true},
        {"name":"Palakkad",  "price": 4400 , "availability":true},
        {"name":"Alappuzha",  "price": 4400 , "availability":true},
        {"name":"Malappuram",  "price": 4400 , "availability":true},
        {"name":"Ponnani",  "price": 4400 , "availability":true},
        {"name":"Vatakara",  "price": 4400 , "availability":true},
        {"name":"Kanhangad",  "price": 4400 , "availability":true},
        {"name":"Taliparamba",  "price": 4400 , "availability":true},
        {"name":"Koyilandy",  "price": 4400 , "availability":true},
        {"name":"Neyyattinkara",  "price": 4400 , "availability":true},
        {"name":"Kayamkulam",  "price": 4400 , "availability":true},
        {"name":"Nedumangad",  "price": 4400 , "availability":true},
        {"name":"Kannur",  "price": 4400 , "availability":true},
        {"name":"Tirur",  "price": 4400 , "availability":true},
        {"name":"Kottayam",  "price": 4400 , "availability":true},
        {"name":"Kasaragod",  "price": 4400 , "availability":true},
        {"name":"Kunnamkulam",  "price": 4400 , "availability":true},
        {"name":"Ottappalam",  "price": 4400 , "availability":true},
        {"name":"Thiruvalla",  "price": 4400 , "availability":true},
        {"name":"Thodupuzha",  "price": 4400 , "availability":true},
        {"name":"Chalakudy",  "price": 4400 , "availability":true},
        {"name":"Changanassery",  "price": 4400 , "availability":true},
        {"name":"Punalur",  "price": 4400 , "availability":true},
        {"name":"Nilambur",  "price": 4400 , "availability":true},
        {"name":"Cherthala",  "price": 4400 , "availability":true},
        {"name":"Perinthalmanna",  "price": 4400 , "availability":true},
        {"name":"Mattannur",  "price": 4400 , "availability":true},
        {"name":"Shoranur",  "price": 4400 , "availability":true},
        {"name":"Varkala",  "price": 4400 , "availability":true},
        {"name":"Paravoor",  "price": 4400 , "availability":true},
        {"name":"Pathanamthitta",  "price": 4400 , "availability":true},
        {"name":"Peringathur",  "price": 4400 , "availability":true},
        {"name":"Attingal",  "price": 4400 , "availability":true},
        {"name":"Kodungallur",  "price": 4400 , "availability":true},
        {"name":"Pappinisseri",  "price": 4400 , "availability":true},
        {"name":"Chittur-Thathamangalam",  "price": 4400 , "availability":true},
        {"name":"Muvattupuzha",  "price": 4400 , "availability":true},
        {"name":"Adoor",  "price": 4400 , "availability":true},
        {"name":"Mavelikkara",  "price": 4400 , "availability":true},
        {"name":"Mavoor",  "price": 4400 , "availability":true},
        {"name":"Perumbavoor",  "price": 4400 , "availability":true},
        {"name":"Vaikom",  "price": 4400 , "availability":true},
        {"name":"Palai",  "price": 4400 , "availability":true},
        {"name":"Panniyannur",  "price": 4400 , "availability":true},
        {"name":"Guruvayoor",  "price": 4400 , "availability":true},
        {"name":"Puthuppally",  "price": 4400 , "availability":true},
        {"name":"Panamattom",  "price": 4400 , "availability":true}
    ],
    "Delhi": [
        {"name":"Delhi",  "price": 4400 , "availability":true},
        {"name":"New Delhi",  "price": 4400 , "availability":true}
    ],
    "Dadra and Nagar Haveli": [
        {"name":"Silvassa",  "price": 4400 , "availability":true}
    ],
    "Puducherry": [
        {"name":"Pondicherry",  "price": 4400 , "availability":true},
        {"name":"Karaikal",  "price": 4400 , "availability":true},
        {"name":"Yanam",  "price": 4400 , "availability":true},
        {"name":"Mahe",  "price": 4400 , "availability":true}
    ],
    "Uttarakhand": [
        {"name":"Dehradun",  "price": 4400 , "availability":true},
        {"name":"Hardwar",  "price": 4400 , "availability":true},
       {"name": "Haldwani-cum-Kathgodam",  "price": 4400 , "availability":true},
        {"name":"Srinagar",  "price": 4400 , "availability":true},
        {"name":"Kashipur",  "price": 4400 , "availability":true},
        {"name":"Roorkee",  "price": 4400 , "availability":true},
        {"name":"Rudrapur",  "price": 4400 , "availability":true},
        {"name":"Rishikesh",  "price": 4400 , "availability":true},
        {"name":"Ramnagar",  "price": 4400 , "availability":true},
        {"name":"Pithoragarh",  "price": 4400 , "availability":true},
        {"name":"Manglaur",  "price": 4400 , "availability":true},
        {"name":"Nainital",  "price": 4400 , "availability":true},
        {"name":"Mussoorie",  "price": 4400 , "availability":true},
        {"name":"Tehri",  "price": 4400 , "availability":true},
        {"name":"Pauri",  "price": 4400 , "availability":true},
        {"name":"Nagla",  "price": 4400 , "availability":true},
        {"name":"Sitarganj",  "price": 4400 , "availability":true},
        {"name":"Bageshwar",  "price": 4400 , "availability":true}
    ],
    "Uttar Pradesh": [
        {"name":"Lucknow",  "price": 4400 , "availability":true},
        {"name":"Kanpur",  "price": 4400 , "availability":true},
        {"name":"Firozabad",  "price": 4400 , "availability":true},
        {"name":"Agra",  "price": 4400 , "availability":true},
        {"name":"Meerut",  "price": 4400 , "availability":true},
        {"name":"Varanasi",  "price": 4400 , "availability":true},
        {"name":"Allahabad",  "price": 4400 , "availability":true},
        {"name":"Amroha",  "price": 4400 , "availability":true},
        {"name":"Moradabad",  "price": 4400 , "availability":true},
        {"name":"Aligarh",  "price": 4400 , "availability":true},
        {"name":"Saharanpur",  "price": 4400 , "availability":true},
        {"name":"Noida",  "price": 4400 , "availability":true},
        {"name":"Loni",  "price": 4400 , "availability":true},
        {"name":"Jhansi",  "price": 4400 , "availability":true},
        {"name":"Shahjahanpur",  "price": 4400 , "availability":true},
        {"name":"Rampur",  "price": 4400 , "availability":true},
        {"name":"Modinagar",  "price": 4400 , "availability":true},
        {"name":"Hapur",  "price": 4400 , "availability":true},
        {"name":"Etawah",  "price": 4400 , "availability":true},
        {"name":"Sambhal",  "price": 4400 , "availability":true},
        {"name":"Orai",  "price": 4400 , "availability":true},
        {"name":"Bahraich",  "price": 4400 , "availability":true},
        {"name":"Unnao",  "price": 4400 , "availability":true},
        {"name":"Rae Bareli",  "price": 4400 , "availability":true},
        {"name":"Lakhimpur",  "price": 4400 , "availability":true},
        {"name":"Sitapur",  "price": 4400 , "availability":true},
        {"name":"Lalitpur",  "price": 4400 , "availability":true},
        {"name":"Pilibhit",  "price": 4400 , "availability":true},
        {"name":"Chandausi",  "price": 4400 , "availability":true},
        {"name":"Hardoi ",  "price": 4400 , "availability":true},
        {"name":"Azamgarh",  "price": 4400 , "availability":true},
        {"name":"Khair",  "price": 4400 , "availability":true},
        {"name":"Sultanpur",  "price": 4400 , "availability":true},
        {"name":"Tanda",  "price": 4400 , "availability":true},
        {"name":"Nagina",  "price": 4400 , "availability":true},
        {"name":"Shamli",  "price": 4400 , "availability":true},
        {"name":"Najibabad",  "price": 4400 , "availability":true},
        {"name":"Shikohabad",  "price": 4400 , "availability":true},
        {"name":"Sikandrabad",  "price": 4400 , "availability":true},
        {"name":"Shahabad Hardoi",  "price": 4400 , "availability":true},
        {"name":"Pilkhuwa",  "price": 4400 , "availability":true},
        {"name":"Renukoot",  "price": 4400 , "availability":true},
        {"name":"Vrindavan",  "price": 4400 , "availability":true},
        {"name":"Ujhani",  "price": 4400 , "availability":true},
        {"name":"Laharpur",  "price": 4400 , "availability":true},
        {"name":"Tilhar",  "price": 4400 , "availability":true},
        {"name":"Sahaswan",  "price": 4400 , "availability":true},
        {"name":"Rath",  "price": 4400 , "availability":true},
        {"name":"Sherkot",  "price": 4400 , "availability":true},
        {"name":"Kalpi",  "price": 4400 , "availability":true},
        {"name":"Tundla",  "price": 4400 , "availability":true},
        {"name":"Sandila",  "price": 4400 , "availability":true},
        {"name":"Nanpara",  "price": 4400 , "availability":true},
        {"name":"Sardhana",  "price": 4400 , "availability":true},
        {"name":"Nehtaur",  "price": 4400 , "availability":true},
        {"name":"Seohara",  "price": 4400 , "availability":true},
        {"name":"Padrauna",  "price": 4400 , "availability":true},
        {"name":"Mathura",  "price": 4400 , "availability":true},
        {"name":"Thakurdwara",  "price": 4400 , "availability":true},
        {"name":"Nawabganj",  "price": 4400 , "availability":true},
        {"name":"Siana",  "price": 4400 , "availability":true},
        {"name":"Noorpur",  "price": 4400 , "availability":true},
        {"name":"Sikandra Rao",  "price": 4400 , "availability":true},
        {"name":"Puranpur",  "price": 4400 , "availability":true},
        {"name":"Rudauli",  "price": 4400 , "availability":true},
        {"name":"Thana Bhawan",  "price": 4400 , "availability":true},
        {"name":"Palia Kalan",  "price": 4400 , "availability":true},
        {"name":"Zaidpur",  "price": 4400 , "availability":true},
        {"name":"Nautanwa",  "price": 4400 , "availability":true},
        {"name":"Zamania",  "price": 4400 , "availability":true},
        {"name":"Shikarpur-Bulandshahr",  "price": 4400 , "availability":true},
        {"name":"Naugawan Sadat",  "price": 4400 , "availability":true},
        {"name":"Fatehpur Sikri",  "price": 4400 , "availability":true},
        {"name":"Shahabad Rampur",  "price": 4400 , "availability":true},
        {"name":"Robertsganj",  "price": 4400 , "availability":true},
        {"name":"Utraula",  "price": 4400 , "availability":true},
        {"name":"Sadabad",  "price": 4400 , "availability":true},
        {"name":"Rasra",  "price": 4400 , "availability":true},
        {"name":"Lar",  "price": 4400 , "availability":true},
         {"name":"LalGopalganj Nindaura",  "price": 4400 , "availability":true},
        {"name":"Sirsaganj",  "price": 4400 , "availability":true},
        {"name":"Pihani",  "price": 4400 , "availability":true},
        {"name":"Shamsabad-Agra",  "price": 4400 , "availability":true},
        {"name":"Rudrapur",  "price": 4400 , "availability":true},
        {"name":"Soron",  "price": 4400 , "availability":true},
        {"name":"SUrban Agglomerationr",  "price": 4400 , "availability":true},
        {"name":"Samdhan",  "price": 4400 , "availability":true},
        {"name":"Sahjanwa",  "price": 4400 , "availability":true},
        {"name":"Rampur Maniharan",  "price": 4400 , "availability":true},
        {"name":"Sumerpur",  "price": 4400 , "availability":true},
        {"name":"Shahganj",  "price": 4400 , "availability":true},
        {"name":"Tulsipur",  "price": 4400 , "availability":true},
        {"name":"Tirwaganj",  "price": 4400 , "availability":true},
        {"name":"PurqUrban Agglomerationzi",  "price": 4400 , "availability":true},
       {"name": "Shamsabad-Farrukhabad",  "price": 4400 , "availability":true},
        {"name":"Warhapur",  "price": 4400 , "availability":true},
        {"name":"Powayan",  "price": 4400 , "availability":true},
        {"name":"Sandi",  "price": 4400 , "availability":true},
        {"name":"Achhnera",  "price": 4400 , "availability":true},
        {"name":"Naraura",  "price": 4400 , "availability":true},
        {"name":"Nakur",  "price": 4400 , "availability":true},
        {"name":"Sahaspur",  "price": 4400 , "availability":true},
        {"name":"Safipur",  "price": 4400 , "availability":true},
        {"name":"Reoti",  "price": 4400 , "availability":true},
        {"name":"Sikanderpur",  "price": 4400 , "availability":true},
        {"name":"Saidpur",  "price": 4400 , "availability":true},
        {"name":"Sirsi",  "price": 4400 , "availability":true},
        {"name":"Purwa",  "price": 4400 , "availability":true},
        {"name":"Parasi",  "price": 4400 , "availability":true},
        {"name":"Lalganj",  "price": 4400 , "availability":true},
        {"name":"Phulpur",  "price": 4400 , "availability":true},
        {"name":"Shishgarh",  "price": 4400 , "availability":true},
        {"name":"Sahawar",  "price": 4400 , "availability":true},
        {"name":"Samthar",  "price": 4400 , "availability":true},
        {"name":"Pukhrayan",  "price": 4400 , "availability":true},
        {"name":"Obra",  "price": 4400 , "availability":true},
        {"name":"Niwai",  "price": 4400 , "availability":true},
        {"name":"Mirzapur",  "price": 4400 , "availability":true}
    ],
    "Bihar": [
        {"name":"Patna",  "price": 4400 , "availability":true},
        {"name":"Gaya",  "price": 4400 , "availability":true},
        {"name":"Bhagalpur",  "price": 4400 , "availability":true},
        {"name":"Muzaffarpur",  "price": 4400 , "availability":true},
        {"name":"Darbhanga",  "price": 4400 , "availability":true},
        {"name":"Arrah",  "price": 4400 , "availability":true},
        {"name":"Begusarai",  "price": 4400 , "availability":true},
        {"name":"Chhapra",  "price": 4400 , "availability":true},
        {"name":"Katihar",  "price": 4400 , "availability":true},
        {"name":"Munger",  "price": 4400 , "availability":true},
        {"name":"Purnia",  "price": 4400 , "availability":true},
        {"name":"Saharsa",  "price": 4400 , "availability":true},
        {"name":"Sasaram",  "price": 4400 , "availability":true},
        {"name":"Hajipur",  "price": 4400 , "availability":true},
        {"name":"Dehri-on-Sone",  "price": 4400 , "availability":true},
        {"name":"Bettiah",  "price": 4400 , "availability":true},
        {"name":"Motihari",  "price": 4400 , "availability":true},
        {"name":"Bagaha",  "price": 4400 , "availability":true},
        {"name":"Siwan",  "price": 4400 , "availability":true},
        {"name":"Kishanganj",  "price": 4400 , "availability":true},
        {"name":"Jamalpur",  "price": 4400 , "availability":true},
        {"name":"Buxar",  "price": 4400 , "availability":true},
        {"name":"Jehanabad",  "price": 4400 , "availability":true},
        {"name":"Aurangabad",  "price": 4400 , "availability":true},
        {"name":"Lakhisarai",  "price": 4400 , "availability":true},
        {"name":"Nawada",  "price": 4400 , "availability":true},
        {"name":"Jamui",  "price": 4400 , "availability":true},
        {"name":"Sitamarhi",  "price": 4400 , "availability":true},
        {"name":"Araria",  "price": 4400 , "availability":true},
        {"name":"Gopalganj",  "price": 4400 , "availability":true},
        {"name":"Madhubani",  "price": 4400 , "availability":true},
        {"name":"Masaurhi",  "price": 4400 , "availability":true},
        {"name":"Samastipur",  "price": 4400 , "availability":true},
        {"name":"Mokameh",  "price": 4400 , "availability":true},
        {"name":"Supaul",  "price": 4400 , "availability":true},
        {"name":"Dumraon",  "price": 4400 , "availability":true},
        {"name":"Arwal",  "price": 4400 , "availability":true},
        {"name":"Forbesganj",  "price": 4400 , "availability":true},
        {"name":"BhabUrban Agglomeration",  "price": 4400 , "availability":true},
        {"name":"Narkatiaganj",  "price": 4400 , "availability":true},
        {"name":"Naugachhia",  "price": 4400 , "availability":true},
        {"name":"Madhepura",  "price": 4400 , "availability":true},
        {"name":"Sheikhpura",  "price": 4400 , "availability":true},
        {"name":"Sultanganj",  "price": 4400 , "availability":true},
        {"name":"Raxaul Bazar",  "price": 4400 , "availability":true},
        {"name":"Ramnagar",  "price": 4400 , "availability":true},
        {"name":"Mahnar Bazar",  "price": 4400 , "availability":true},
        {"name":"Warisaliganj",  "price": 4400 , "availability":true},
        {"name":"Revelganj",  "price": 4400 , "availability":true},
        {"name":"Rajgir",  "price": 4400 , "availability":true},
        {"name":"Sonepur",  "price": 4400 , "availability":true},
        {"name":"Sherghati",  "price": 4400 , "availability":true},
        {"name":"Sugauli",  "price": 4400 , "availability":true},
        {"name":"Makhdumpur",  "price": 4400 , "availability":true},
        {"name":"Maner",  "price": 4400 , "availability":true},
        {"name":"Rosera",  "price": 4400 , "availability":true},
        {"name":"Nokha",  "price": 4400 , "availability":true},
        {"name":"Piro",  "price": 4400 , "availability":true},
        {"name":"Rafiganj",  "price": 4400 , "availability":true},
        {"name":"Marhaura",  "price": 4400 , "availability":true},
        {"name":"Mirganj",  "price": 4400 , "availability":true},
        {"name":"Lalganj",  "price": 4400 , "availability":true},
        {"name":"Murliganj",  "price": 4400 , "availability":true},
        {"name":"Motipur",  "price": 4400 , "availability":true},
        {"name":"Manihari",  "price": 4400 , "availability":true},
        {"name":"Sheohar",  "price": 4400 , "availability":true},
        {"name":"Maharajganj",  "price": 4400 , "availability":true},
        {"name":"Silao",  "price": 4400 , "availability":true},
        {"name":"Barh",  "price": 4400 , "availability":true},
        {"name":"Asarganj",  "price": 4400 , "availability":true}
    ],
    "Gujarat": [
        {"name":"Ahmedabad",  "price": 4400 , "availability":true},
        {"name":"Surat",  "price": 4400 , "availability":true},
        {"name":"Vadodara",  "price": 4400 , "availability":true},
        {"name":"Rajkot",  "price": 4400 , "availability":true},
        {"name":"Bhavnagar",  "price": 4400 , "availability":true},
        {"name":"Jamnagar",  "price": 4400 , "availability":true},
        {"name":"Nadiad",  "price": 4400 , "availability":true},
        {"name":"Porbandar",  "price": 4400 , "availability":true},
        {"name":"Anand",  "price": 4400 , "availability":true},
        {"name":"Morvi",  "price": 4400 , "availability":true},
        {"name":"Mahesana",  "price": 4400 , "availability":true},
        {"name":"Bharuch",  "price": 4400 , "availability":true},
        {"name":"Vapi",  "price": 4400 , "availability":true},
        {"name":"Navsari",  "price": 4400 , "availability":true},
        {"name":"Veraval",  "price": 4400 , "availability":true},
        {"name":"Bhuj",  "price": 4400 , "availability":true},
        {"name":"Godhra",  "price": 4400 , "availability":true},
        {"name":"Palanpur",  "price": 4400 , "availability":true},
        {"name":"Valsad",  "price": 4400 , "availability":true},
        {"name":"Patan",  "price": 4400 , "availability":true},
        {"name":"Deesa",  "price": 4400 , "availability":true},
        {"name":"Amreli",  "price": 4400 , "availability":true},
        {"name":"Anjar",  "price": 4400 , "availability":true},
        {"name":"Dhoraji",  "price": 4400 , "availability":true},
        {"name":"Khambhat",  "price": 4400 , "availability":true},
        {"name":"Mahuva",  "price": 4400 , "availability":true},
        {"name":"Keshod",  "price": 4400 , "availability":true},
        {"name":"Wadhwan",  "price": 4400 , "availability":true},
        {"name":"Ankleshwar",  "price": 4400 , "availability":true},
        {"name":"Savarkundla",  "price": 4400 , "availability":true},
        {"name":"Kadi",  "price": 4400 , "availability":true},
        {"name":"Visnagar",  "price": 4400 , "availability":true},
        {"name":"Upleta",  "price": 4400 , "availability":true},
        {"name":"Una",  "price": 4400 , "availability":true},
        {"name":"Sidhpur",  "price": 4400 , "availability":true},
        {"name":"Unjha",  "price": 4400 , "availability":true},
        {"name":"Mangrol",  "price": 4400 , "availability":true},
        {"name":"Viramgam",  "price": 4400 , "availability":true},
        {"name":"Modasa",  "price": 4400 , "availability":true},
        {"name":"Palitana",  "price": 4400 , "availability":true},
        {"name":"Petlad",  "price": 4400 , "availability":true},
        {"name":"Kapadvanj",  "price": 4400 , "availability":true},
        {"name":"Sihor",  "price": 4400 , "availability":true},
        {"name":"Wankaner",  "price": 4400 , "availability":true},
        {"name":"Limbdi",  "price": 4400 , "availability":true},
        {"name":"Mandvi",  "price": 4400 , "availability":true},
        {"name":"Thangadh",  "price": 4400 , "availability":true},
        {"name":"Vyara",  "price": 4400 , "availability":true},
        {"name":"Padra",  "price": 4400 , "availability":true},
        {"name":"Lunawada",  "price": 4400 , "availability":true},
        {"name":"Rajpipla",  "price": 4400 , "availability":true},
        {"name":"Vapi",  "price": 4400 , "availability":true},
        {"name":"Umreth",  "price": 4400 , "availability":true},
        {"name":"Sanand",  "price": 4400 , "availability":true},
        {"name":"Rajula",  "price": 4400 , "availability":true},
        {"name":"Radhanpur",  "price": 4400 , "availability":true},
        {"name":"Mahemdabad",  "price": 4400 , "availability":true},
        {"name":"Ranavav",  "price": 4400 , "availability":true},
        {"name":"Tharad",  "price": 4400 , "availability":true},
        {"name":"Mansa",  "price": 4400 , "availability":true},
        {"name":"Umbergaon",  "price": 4400 , "availability":true},
        {"name":"Talaja",  "price": 4400 , "availability":true},
        {"name":"Vadnagar",  "price": 4400 , "availability":true},
        {"name":"Manavadar",  "price": 4400 , "availability":true},
        {"name":"Salaya",  "price": 4400 , "availability":true},
        {"name":"Vijapur",  "price": 4400 , "availability":true},
        {"name":"Pardi",  "price": 4400 , "availability":true},
        {"name":"Rapar",  "price": 4400 , "availability":true},
        {"name":"Songadh",  "price": 4400 , "availability":true},
        {"name":"Lathi",  "price": 4400 , "availability":true},
        {"name":"Adalaj",  "price": 4400 , "availability":true},
        {"name":"Chhapra",  "price": 4400 , "availability":true},
        {"name":"Gandhinagar",  "price": 4400 , "availability":true}
    ],
    "Telangana": [
        {"name":"Hyderabad",  "price": 4400 , "availability":true},
        {"name":"Warangal",  "price": 4400 , "availability":true},
        {"name":"Nizamabad",  "price": 4400 , "availability":true},
        {"name":"Karimnagar",  "price": 4400 , "availability":true},
        {"name":"Ramagundam",  "price": 4400 , "availability":true},
        {"name":"Khammam",  "price": 4400 , "availability":true},
        {"name":"Mahbubnagar",  "price": 4400 , "availability":true},
        {"name":"Mancherial",  "price": 4400 , "availability":true},
        {"name":"Adilabad",  "price": 4400 , "availability":true},
        {"name":"Suryapet",  "price": 4400 , "availability":true},
        {"name":"Jagtial",  "price": 4400 , "availability":true},
        {"name":"Miryalaguda",  "price": 4400 , "availability":true},
        {"name":"Nirmal",  "price": 4400 , "availability":true},
        {"name":"Kamareddy",  "price": 4400 , "availability":true},
        {"name":"Kothagudem",  "price": 4400 , "availability":true},
        {"name":"Bodhan",  "price": 4400 , "availability":true},
        {"name":"Palwancha",  "price": 4400 , "availability":true},
        {"name":"Mandamarri",  "price": 4400 , "availability":true},
        {"name":"Koratla",  "price": 4400 , "availability":true},
        {"name":"Sircilla",  "price": 4400 , "availability":true},
        {"name":"Tandur",  "price": 4400 , "availability":true},
        {"name":"Siddipet",  "price": 4400 , "availability":true},
        {"name":"Wanaparthy",  "price": 4400 , "availability":true},
        {"name":"Kagaznagar",  "price": 4400 , "availability":true},
        {"name":"Gadwal",  "price": 4400 , "availability":true},
        {"name":"Sangareddy",  "price": 4400 , "availability":true},
        {"name":"Bellampalle",  "price": 4400 , "availability":true},
        {"name":"Bhongir",  "price": 4400 , "availability":true},
        {"name":"Vikarabad",  "price": 4400 , "availability":true},
        {"name":"Jangaon",  "price": 4400 , "availability":true},
        {"name":"Bhadrachalam",  "price": 4400 , "availability":true},
        {"name":"Bhainsa",  "price": 4400 , "availability":true},
        {"name":"Farooqnagar",  "price": 4400 , "availability":true},
        {"name":"Medak",  "price": 4400 , "availability":true},
        {"name":"Narayanpet",  "price": 4400 , "availability":true},
        {"name":"Sadasivpet",  "price": 4400 , "availability":true},
        {"name":"Yellandu",  "price": 4400 , "availability":true},
        {"name":"Manuguru",  "price": 4400 , "availability":true},
        {"name":"Kyathampalle",  "price": 4400 , "availability":true},
        {"name":"Nagarkurnool",  "price": 4400 , "availability":true}
    ],
    "Meghalaya": [
        {"name":"Shillong",  "price": 4400 , "availability":true},
        {"name":"Tura",  "price": 4400 , "availability":true},
        {"name":"Nongstoin",  "price": 4400 , "availability":true}
    ],
    "Himachal Praddesh": [
        {"name":"Manali",  "price": 4400 , "availability":true}
    ],
    "Arunachal Pradesh": [
        {"name":"Naharlagun",  "price": 4400 , "availability":true},
        {"name":"Pasighat",  "price": 4400 , "availability":true}
    ],
    "Maharashtra": [
        {"name":"Mumbai",  "price": 4400 , "availability":true},
        {"name":"Pune",  "price": 4400 , "availability":true},
        {"name":"Nagpur",  "price": 4400 , "availability":true},
        {"name":"Thane",  "price": 4400 , "availability":true},
        {"name":"Nashik",  "price": 4400 , "availability":true},
        {"name":"Kalyan-Dombivali",  "price": 4400 , "availability":true},
        {"name":"Vasai-Virar",  "price": 4400 , "availability":true},
        {"name":"Solapur",  "price": 4400 , "availability":true},
        {"name":"Mira-Bhayandar",  "price": 4400 , "availability":true},
        {"name":"Bhiwandi",  "price": 4400 , "availability":true},
        {"name":"Amravati",  "price": 4400 , "availability":true},
        {"name":"Nanded-Waghala",  "price": 4400 , "availability":true},
        {"name":"Sangli",  "price": 4400 , "availability":true},
        {"name":"Malegaon",  "price": 4400 , "availability":true},
        {"name":"Akola",  "price": 4400 , "availability":true},
        {"name":"Latur",  "price": 4400 , "availability":true},
        {"name":"Dhule",  "price": 4400 , "availability":true},
        {"name":"Ahmednagar",  "price": 4400 , "availability":true},
        {"name":"Ichalkaranji",  "price": 4400 , "availability":true},
        {"name":"Parbhani",  "price": 4400 , "availability":true},
        {"name":"Panvel",  "price": 4400 , "availability":true},
        {"name":"Yavatmal",  "price": 4400 , "availability":true},
        {"name":"Achalpur",  "price": 4400 , "availability":true},
        {"name":"Osmanabad",  "price": 4400 , "availability":true},
        {"name":"Nandurbar",  "price": 4400 , "availability":true},
        {"name":"Satara",  "price": 4400 , "availability":true},
        {"name":"Wardha",  "price": 4400 , "availability":true},
        {"name":"Udgir",  "price": 4400 , "availability":true},
        {"name":"Aurangabad",  "price": 4400 , "availability":true},
        {"name":"Amalner",  "price": 4400 , "availability":true},
        {"name":"Akot",  "price": 4400 , "availability":true},
        {"name":"Pandharpur",  "price": 4400 , "availability":true},
        {"name":"Shrirampur",  "price": 4400 , "availability":true},
        {"name":"Parli",  "price": 4400 , "availability":true},
        {"name":"Washim",  "price": 4400 , "availability":true},
        {"name":"Ambejogai",  "price": 4400 , "availability":true},
        {"name":"Manmad",  "price": 4400 , "availability":true},
        {"name":"Ratnagiri",  "price": 4400 , "availability":true},
        {"name":"Uran Islampur",  "price": 4400 , "availability":true},
        {"name":"Pusad",  "price": 4400 , "availability":true},
        {"name":"Sangamner",  "price": 4400 , "availability":true},
        {"name":"Shirpur-Warwade",  "price": 4400 , "availability":true},
        {"name":"Malkapur",  "price": 4400 , "availability":true},
        {"name":"Wani",  "price": 4400 , "availability":true},
        {"name":"Lonavla",  "price": 4400 , "availability":true},
        {"name":"Talegaon Dabhade",  "price": 4400 , "availability":true},
        {"name":"Anjangaon",  "price": 4400 , "availability":true},
        {"name":"Umred",  "price": 4400 , "availability":true},
        {"name":"Palghar",  "price": 4400 , "availability":true},
        {"name":"Shegaon",  "price": 4400 , "availability":true},
        {"name":"Ozar",  "price": 4400 , "availability":true},
        {"name":"Phaltan",  "price": 4400 , "availability":true},
        {"name":"Yevla",  "price": 4400 , "availability":true},
        {"name":"Shahade",  "price": 4400 , "availability":true},
        {"name":"Vita",  "price": 4400 , "availability":true},
        {"name":"Umarkhed",  "price": 4400 , "availability":true},
        {"name":"Warora",  "price": 4400 , "availability":true},
        {"name":"Pachora",  "price": 4400 , "availability":true},
        {"name":"Tumsar",  "price": 4400 , "availability":true},
        {"name":"Manjlegaon",  "price": 4400 , "availability":true},
        {"name":"Sillod",  "price": 4400 , "availability":true},
        {"name":"Arvi",  "price": 4400 , "availability":true},
        {"name":"Nandura",  "price": 4400 , "availability":true},
        {"name":"Vaijapur",  "price": 4400 , "availability":true},
        {"name":"Wadgaon Road",  "price": 4400 , "availability":true},
        {"name":"Sailu",  "price": 4400 , "availability":true},
        {"name":"Murtijapur",  "price": 4400 , "availability":true},
        {"name":"Tasgaon",  "price": 4400 , "availability":true},
        {"name":"Mehkar",  "price": 4400 , "availability":true},
        {"name":"Yawal",  "price": 4400 , "availability":true},
        {"name":"Pulgaon",  "price": 4400 , "availability":true},
        {"name":"Nilanga",  "price": 4400 , "availability":true},
        {"name":"Wai",  "price": 4400 , "availability":true},
        {"name":"Umarga",  "price": 4400 , "availability":true},
        {"name":"Paithan",  "price": 4400 , "availability":true},
        {"name":"Rahuri",  "price": 4400 , "availability":true},
        {"name":"Nawapur",  "price": 4400 , "availability":true},
        {"name":"Tuljapur",  "price": 4400 , "availability":true},
        {"name":"Morshi",  "price": 4400 , "availability":true},
        {"name":"Purna",  "price": 4400 , "availability":true},
        {"name":"Satana",  "price": 4400 , "availability":true},
        {"name":"Pathri",  "price": 4400 , "availability":true},
        {"name":"Sinnar",  "price": 4400 , "availability":true},
        {"name":"Uchgaon",  "price": 4400 , "availability":true},
        {"name":"Uran",  "price": 4400 , "availability":true},
        {"name":"Pen",  "price": 4400 , "availability":true},
        {"name":"Karjat",  "price": 4400 , "availability":true},
        {"name":"Manwath",  "price": 4400 , "availability":true},
        {"name":"Partur",  "price": 4400 , "availability":true},
        {"name":"Sangole",  "price": 4400 , "availability":true},
        {"name":"Mangrulpir",  "price": 4400 , "availability":true},
        {"name":"Risod",  "price": 4400 , "availability":true},
        {"name":"Shirur",  "price": 4400 , "availability":true},
        {"name":"Savner",  "price": 4400 , "availability":true},
        {"name":"Sasvad",  "price": 4400 , "availability":true},
        {"name":"Pandharkaoda",  "price": 4400 , "availability":true},
        {"name":"Talode",  "price": 4400 , "availability":true},
        {"name":"Shrigonda",  "price": 4400 , "availability":true},
        {"name":"Shirdi",  "price": 4400 , "availability":true},
        {"name":"Raver",  "price": 4400 , "availability":true},
        {"name":"Mukhed",  "price": 4400 , "availability":true},
        {"name":"Rajura",  "price": 4400 , "availability":true},
        {"name":"Vadgaon Kasba",  "price": 4400 , "availability":true},
        {"name":"Tirora",  "price": 4400 , "availability":true},
        {"name":"Mahad",  "price": 4400 , "availability":true},
        {"name":"Lonar",  "price": 4400 , "availability":true},
        {"name":"Sawantwadi",  "price": 4400 , "availability":true},
        {"name":"Pathardi",  "price": 4400 , "availability":true},
        {"name":"Pauni",  "price": 4400 , "availability":true},
        {"name":"Ramtek",  "price": 4400 , "availability":true},
        {"name":"Mul",  "price": 4400 , "availability":true},
        {"name":"Soyagaon",  "price": 4400 , "availability":true},
        {"name":"Mangalvedhe",  "price": 4400 , "availability":true},
        {"name":"Narkhed",  "price": 4400 , "availability":true},
        {"name":"Shendurjana",  "price": 4400 , "availability":true},
        {"name":"Patur",  "price": 4400 , "availability":true},
        {"name":"Mhaswad",  "price": 4400 , "availability":true},
        {"name":"Loha",  "price": 4400 , "availability":true},
        {"name":"Nandgaon",  "price": 4400 , "availability":true},
        {"name":"Warud",  "price": 4400 , "availability":true}
    ],
    "Goa": [
        {"name":"Marmagao",  "price": 4400 , "availability":true},
        {"name":"Panaji",  "price": 4400 , "availability":true},
        {"name":"Margao",  "price": 4400 , "availability":true},
        {"name":"Mapusa",  "price": 4400 , "availability":true}
    ],
    "West Bengal": [
        {"name":"Kolkata",  "price": 4400 , "availability":true},
        {"name":"Siliguri",  "price": 4400 , "availability":true},
        {"name":"Asansol",  "price": 4400 , "availability":true},
        {"name":"Raghunathganj",  "price": 4400 , "availability":true},
        {"name":"Kharagpur",  "price": 4400 , "availability":true},
        {"name":"Naihati",  "price": 4400 , "availability":true},
        {"name":"English Bazar",  "price": 4400 , "availability":true},
        {"name":"Baharampur",  "price": 4400 , "availability":true},
       {"name": "Hugli-Chinsurah",  "price": 4400 , "availability":true},
        {"name":"Raiganj",  "price": 4400 , "availability":true},
        {"name":"Jalpaiguri",  "price": 4400 , "availability":true},
        {"name":"Santipur",  "price": 4400 , "availability":true},
        {"name":"Balurghat",  "price": 4400 , "availability":true},
        {"name":"Medinipur",  "price": 4400 , "availability":true},
        {"name":"Habra",  "price": 4400 , "availability":true},
        {"name":"Ranaghat",  "price": 4400 , "availability":true},
        {"name":"Bankura",  "price": 4400 , "availability":true},
        {"name":"Nabadwip",  "price": 4400 , "availability":true},
        {"name":"Darjiling",  "price": 4400 , "availability":true},
        {"name":"Purulia",  "price": 4400 , "availability":true},
        {"name":"Arambagh",  "price": 4400 , "availability":true},
        {"name":"Tamluk",  "price": 4400 , "availability":true},
        {"name":"AlipurdUrban Agglomerationr",  "price": 4400 , "availability":true},
        {"name":"Suri",  "price": 4400 , "availability":true},
        {"name":"Jhargram",  "price": 4400 , "availability":true},
        {"name":"Gangarampur",  "price": 4400 , "availability":true},
        {"name":"Rampurhat",  "price": 4400 , "availability":true},
        {"name":"Kalimpong",  "price": 4400 , "availability":true},
        {"name":"Sainthia",  "price": 4400 , "availability":true},
        {"name":"Taki",  "price": 4400 , "availability":true},
        {"name":"Murshidabad",  "price": 4400 , "availability":true},
        {"name":"Memari",  "price": 4400 , "availability":true},
        {"name":"Paschim Punropara",  "price": 4400 , "availability":true},
        {"name":"Tarakeswar",  "price": 4400 , "availability":true},
        {"name":"Sonamukhi",  "price": 4400 , "availability":true},
        {"name":"PandUrban Agglomeration",  "price": 4400 , "availability":true},
        {"name":"Mainaguri",  "price": 4400 , "availability":true},
        {"name":"Malda",  "price": 4400 , "availability":true},
        {"name":"Panchla",  "price": 4400 , "availability":true},
        {"name":"Raghunathpur",  "price": 4400 , "availability":true},
        {"name":"Mathabhanga",  "price": 4400 , "availability":true},
        {"name":"Monoharpur",  "price": 4400 , "availability":true},
        {"name":"Srirampore",  "price": 4400 , "availability":true},
        {"name":"Adra",  "price": 4400 , "availability":true}
    ]
}

export default AIS140Availability;